import Axios from 'axios';
import { Config } from '../apiRoutes';
import { authHeaders } from '../headers';

import {
  PRODUCTS_SEARCH_REQUESTED,
  PRODUCTS_SEARCH_SUCCESS,
  PRODUCTS_SEARCH_FAILURE,
  PRODUCTS_SEARCH_RESET,
} from '../types';

export const productsSearchRequested = () => {
  return {
    type: PRODUCTS_SEARCH_REQUESTED
  }
};

export const productsSearchSuccess = (results) => {
  return {
    type: PRODUCTS_SEARCH_SUCCESS,
    payload: results
  }
};

export const productsSearchFailure = () => {
  return {
    type: PRODUCTS_SEARCH_FAILURE
  }
};

export const productsSearchReset = () => {
  return {
    type: PRODUCTS_SEARCH_RESET
  }
};

// Live Shopify catalog search - products come back with their variants
// nested, so product-level and variant-level rule targets are both
// chosen from the same result set
export const searchProducts = (term, cursor = null) => {
  return async (dispatch) => {
    dispatch(productsSearchRequested());

    const endPoint = Config.baseUrl + Config.productsSearch;

    return Axios.get(endPoint, {
      headers: await authHeaders(),
      params: { term: term, cursor: cursor }
    })
      .then((response) => {
        dispatch(productsSearchSuccess(response.data));
      })
      .catch(() => {
        dispatch(productsSearchFailure());
      });
  }
}
